import { render } from "./ComponenteMaestroRo.vue?vue&type=template&id=f461b578&scoped=true"
import script from "./ComponenteMaestroRo.vue?vue&type=script&lang=js"
export * from "./ComponenteMaestroRo.vue?vue&type=script&lang=js"

import "./ComponenteMaestroRo.vue?vue&type=style&index=0&id=f461b578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f461b578"]])

export default __exports__